import React, { useEffect, useRef, useState } from 'react';

import { Container, Button, Dropdown, DropdownButton, Alert, Col, Row, Spinner, Modal, Tooltip, InputGroup, Form, Tab, Nav } from 'react-bootstrap';
import { EditionService } from '../../services/EditionService';
import { ClientService } from '../../services/ClientService';
import ErrorManager from "../../components/error-manager/ErrorManager";

//import './SendMailDialog.scss';

const SendMailDialog = ({ clientIdList, folderId, editionUrl, params, totalElements, show, setCloseModal }) => {

    const [showModal, setShowModal] = useState(false);
    const [globalError, setGlobalError] = useState();
    const [client, setClient] = useState();
    const [toSendMailList, setToSendMailList] = useState([]);
    const [isSendLoading, setIsSendLoading] = useState(false);
    const [sendDocumentMailsResponse, setSendDocumentMailsResponse] = useState();
    const [isMailSuccess, setIsMailSuccess] = useState(false);
    const [sendMode, setSendMode] = useState();

    let inputRef = useRef();

    useEffect(() => {
        setShowModal(show)
        if (show) {
            resetValues()
            if (totalElements == 1 && clientIdList) {
                setSendMode("tabAutres")
                getClient()
            } else {
                setSendMode("tabAutomatique")
            }
        }
    }, [show]);

    function resetValues() {
        setGlobalError()
        setClient()
        setToSendMailList([])
        setIsSendLoading(false)
        setIsMailSuccess(false)
    }

    function handleClose(e) {
        setCloseModal()
    }

    function addCustomEmail() {
        setToSendMailList([...toSendMailList, inputRef.current.value])
        inputRef.current.value = null
    }

    function onMailSelect(e) {
        setToSendMailList([...toSendMailList, e.target.value])
    }

    function removeMail(mail) {
        setToSendMailList(toSendMailList.filter(m => m !== mail))
    }

    function addPrincipalMail(interlocuteurs) {
        {
            interlocuteurs?.map(interlocuteur => {
                if (interlocuteur.principal && interlocuteur?.mails?.length > 0) {
                    setToSendMailList(interlocuteur.mails)
                }
            })
        }

    }

    function getClient() {
        ClientService.getClient(folderId, clientIdList[0]).then(res => {
            if (!res.data?.data) {
                setGlobalError({ statusText: res.statusText })
            } else {
                setClient(res.data.data)
                addPrincipalMail(res.data.data.interlocuteurs)
            }
        }).catch(error => {
            setGlobalError(error)
        });
    }

    function sendEmails() {
        setIsMailSuccess(false)
        setIsSendLoading(true)
        setGlobalError()

        let requestParams = params ? params : {}

        if (sendMode === "tabAutres") {
            if (toSendMailList) {
                requestParams["emails_direct_delivery"] = toSendMailList
            }
        }

        if (sendMode === "tabAutomatique") {
            requestParams["emails_batch_delivery"] = true
        }

        EditionService.getSendDocumentMails(folderId, editionUrl, requestParams).then(res => {
            setIsSendLoading(false)
            console.log("---res.data")
            console.log(res.data)
            setSendDocumentMailsResponse(res.data)
            if (!res.data) {
                setGlobalError({ statusText: res.statusText })
            } else {
                setIsMailSuccess(true)
            }
        }).catch(error => {
            setGlobalError(error)
            setIsSendLoading(false)
        });

    }

    return (
        <div id="SendMailDialog">
            <Modal show={showModal} onHide={() => handleClose()} centered>
                <Modal.Header closeButton>
                    {(totalElements == 1) ?
                        <Modal.Title>Envoyer le document par mail</Modal.Title>
                        :
                        <Modal.Title>Envoyer {totalElements} documents par mail</Modal.Title>
                    }
                </Modal.Header>
                <Modal.Body>

                    <ErrorManager error={globalError} />

                    {isMailSuccess &&
                        <>
                            {/* Status des emails : ok */}
                            {(sendDocumentMailsResponse.status.type == "OK") &&
                                <Alert variant="success">
                                    <h6 className="m-0">{sendDocumentMailsResponse.status.message}</h6>
                                </Alert>
                            }
                            {/* {sendDocumentMailsResponse?.data?.output?.filter(doc => doc.emails.status == "ok").length > 0 &&
                                <>
                                    <Alert variant="success">
                                        <h6 className="m-0">{sendDocumentMailsResponse?.data?.output?.filter(doc => doc.emails.status == "ok").length} email(s) envoyé(s).</h6>
                                    </Alert>
                                </>
                            } */}

                            {/* Status des emails : spooled */}
                            {sendDocumentMailsResponse?.data?.output?.filter(doc => doc.emails.status == "spooled").length > 0 &&
                                <>
                                    <Alert variant="primary">
                                        <h6>{sendDocumentMailsResponse?.data?.output?.filter(doc => doc.emails.status == "spooled").length} email(s) placé(s) en file d'attente.</h6>
                                        <p>Aux vues du nombre de documents à envoyer, les emails ont été placés en file d’attente. Ils seront définitivement expédiés après validation d’une personne autorisée.</p>
                                    </Alert>
                                </>
                            }

                            {/* Status des emails : partial */}
                            {sendDocumentMailsResponse?.data?.output?.filter(doc => doc.emails.status == "partial").length > 0 &&
                                <>
                                    <Alert variant="warning">
                                        <h6>{sendDocumentMailsResponse?.data?.output?.filter(doc => doc.emails.status == "partial").length} email(s) partiellement envoyé(s).</h6>
                                        <p>Échec sur au moins une adresse email.</p>
                                    </Alert>
                                </>
                            }

                            {/* Status des emails : fail */}
                            {sendDocumentMailsResponse?.data?.output?.filter(doc => doc.emails.status == "fail").length > 0 &&
                                <>
                                    <Alert variant="danger">
                                        <h6 className="m-0">{sendDocumentMailsResponse?.data?.output?.filter(doc => doc.emails.status == "fail").length} email(s) en échec.</h6>
                                    </Alert>
                                </>
                            }

                        </>

                    }

                    {!isMailSuccess &&
                        <Tab.Container defaultActiveKey={sendMode}>
                            {totalElements > 1 &&
                                <Nav variant="pills">
                                    <Nav.Item>
                                        <Nav.Link onClick={() => setSendMode("tabAutomatique")} eventKey="tabAutomatique">Envoi automatique</Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link onClick={() => setSendMode("tabAutres")} eventKey="tabAutres">Autre(s) destinataire(s)</Nav.Link>
                                    </Nav.Item>
                                </Nav>
                            }
                            <Tab.Content>
                                <Tab.Pane className="pt-4" eventKey="tabAutomatique">
                                    <h6>Envoie chaque document à son client (interlocuteur principal)</h6>
                                </Tab.Pane>
                                <Tab.Pane className="pt-4" eventKey="tabAutres">
                                    {totalElements == 1 ?
                                        <h6>Ajouter des destinataires :</h6>
                                        :
                                        <h6>Envoie {totalElements} documents aux adresses saisies ci dessous :</h6>
                                    }

                                    <InputGroup className="mt-3 mb-2">
                                        <Form.Control
                                            placeholder="Ajouter une adresse email"
                                            ref={inputRef}
                                        />
                                        <Button variant="secondary" id="button-addon2" onClick={() => addCustomEmail()} >
                                            Ajouter
                                        </Button>
                                    </InputGroup>

                                    {totalElements == 1 &&
                                        <InputGroup>
                                            <Form.Select onChange={onMailSelect} value="" disabled={client?.interlocuteurs?.filter(i => i.mails.length > 0).length == 0}>
                                                {(client?.interlocuteurs?.filter(i => i.mails.length > 0).length == 0) ?
                                                    <option>- Aucune adresse mail n'est rattachée à ce client -</option>
                                                    :
                                                    <option>- Adresses email du client -</option>
                                                }
                                                {client?.interlocuteurs?.filter(i => i?.mails?.length > 0).map(interlocuteur => (
                                                    <optgroup key={interlocuteur._id} label={`${interlocuteur?.nom} ${interlocuteur?.prenom} ${interlocuteur?.principal ? '(principal)' : ''}`}>
                                                        {interlocuteur.mails.map(mail => (
                                                            <option key={mail} disabled={toSendMailList.includes(mail)} value={mail}>{mail}</option>
                                                        ))}
                                                    </optgroup>
                                                ))}
                                            </Form.Select>
                                        </InputGroup>
                                    }


                                    {toSendMailList.length > 0 &&
                                        <>
                                            <h6 className="mt-3">Destinataires :</h6>
                                            {toSendMailList.map(mail => (
                                                <span key={mail} className="d-inline-flex align-items-center bg-primary-100 border border-primary-200 rounded me-2 mb-2 p-1 small ps-2">
                                                    <span className="me-2 text-primary-800">{mail}</span>
                                                    <span className="px-1 bg-primary-200 text-primary-800 hover-bg-primary-300 rounded cursor-pointer" onClick={() => removeMail(mail)}>
                                                        <i className="material-icons">close</i>
                                                    </span>
                                                </span>
                                            ))}
                                        </>
                                    }

                                </Tab.Pane>
                            </Tab.Content>
                        </Tab.Container>
                    }

                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Fermer
                    </Button>
                    {!isMailSuccess &&
                        <Button disabled={isSendLoading || (toSendMailList.length === 0 && sendMode === "tabAutres")} className="float-end ms-1" onClick={() => sendEmails()} >
                            {isSendLoading && <Spinner animation="border" size="sm" className="me-2" />}
                            Envoyer les emails
                        </Button>
                    }
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default SendMailDialog;
